// extracted by mini-css-extract-plugin
export default {"header":"Header_header__c9P6n","toggle":"Header_toggle__iGgVV","mobile":"Header_mobile__NWVvn"};